import React from "react";
import PostTitleSection from "~/Brochure/FoodServiceResources/Shared/Components/PostTitleSection";
import { BlogPost } from "../utilities";
interface BlogPostTitleSectionProps {
  post: BlogPost;
  additionalContainerClasses?: string;
}
const BlogPostTitleSection = ({
  post,
  additionalContainerClasses
}: Readonly<BlogPostTitleSectionProps>) => {
  const {
    authorDisplayName,
    categories,
    title,
    datePosted
  } = post;
  return <PostTitleSection additionalContainerClasses={additionalContainerClasses} additionalHeaderClasses="!py-0" author={authorDisplayName} categories={categories} dateModified={datePosted} displayHeader={title} data-sentry-element="PostTitleSection" data-sentry-component="BlogPostTitleSection" data-sentry-source-file="BlogPostTitleSection.tsx" />;
};
export default BlogPostTitleSection;